'use strict';
import $ from 'jquery';
import 'jquery-match-height';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default class M120 {
  static init() {
    $('.module-m120').each((index, el) => {
      new M120($(el));
    });
  }

  constructor($el) {
    this.el = $el;

    this.el.find('.module-m120-items').on('pagination', (event, slick) => {
      $el.find('.module-m120-items-item').matchHeight();
    });

    const swiperSettings = {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      slidesPerGroup: 1,
      navigation: {
        enabled: true,
        prevEl: $el.find('.swiper-button-prev').get(0),
        nextEl: $el.find('.swiper-button-next').get(0),
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          // pagination: {
          //   enabled: false,
          // },
        },
        992: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          // pagination: {
          //   enabled: false,
          // },
        }
      },
      on: {
        init: () => {
          $el.find('.module-m120-items-item').matchHeight();
        }
      }
    };
    const swiper = new Swiper(this.el.find('.module-m120-items').get(0), swiperSettings);
    let windowWidth = $(window).width();
    if (
      windowWidth > 767 && this.el.find('.module-m120-items-item').length <= 3 ||
      windowWidth < 768 && this.el.find('.module-m120-items-item').length === 1

    ) {
      this.el.find('.module-m120-nav').hide();
    }
  }
}
